/**
 * Utilitaires pour générer des fichiers de démonstration / tests pour la GED EasyCompta
 */

export const generateSamplePdfBlob = (
  title = "Facture_Justificatif.pdf",
  partner = "Fournisseur Test",
  amount = 150000,
  folder = "401 - Achats & Fournisseurs",
  docType = "Facture Fournisseur"
) => {
  const dateStr = new Date().toLocaleDateString("fr-FR");
  const amountStr = new Intl.NumberFormat("fr-FR").format(amount) + " FCFA";

  // PDF 1.4 minimal standard valide
  const pdfBody = `%PDF-1.4
1 0 obj
<< /Type /Catalog /Pages 2 0 R >>
endobj
2 0 obj
<< /Type /Pages /Kids [3 0 R] /Count 1 >>
endobj
3 0 obj
<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Contents 4 0 R /Resources << /Font << /F1 5 0 R >> >> >>
endobj
4 0 obj
<< /Length 320 >>
stream
BT
/F1 16 Tf
50 730 Td
(EASY COMPTA - PIECE COMPTABLE NUMERISEE) Tj
/F1 11 Tf
0 -30 Td
(Intitule : ${title.replace(/[()]/g, "")}) Tj
0 -20 Td
(Type : ${docType.replace(/[()]/g, "")}) Tj
0 -20 Td
(Partenaire / Tiers : ${partner.replace(/[()]/g, "")}) Tj
0 -20 Td
(Dossier SYSCOHADA : ${folder.replace(/[()]/g, "")}) Tj
0 -20 Td
(Montant Total : ${amountStr.replace(/[()]/g, "")}) Tj
0 -20 Td
(Date de certification : ${dateStr}) Tj
0 -35 Td
(Certification numerique conforme aux normes OHADA / SYSCOHADA) Tj
ET
endstream
endobj
5 0 obj
<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>
endobj
xref
0 6
0000000000 65535 f 
0000000009 00000 n 
0000000058 00000 n 
0000000115 00000 n 
0000000234 00000 n 
0000000600 00000 n 
trailer
<< /Size 6 /Root 1 0 R >>
startxref
670
%%EOF`;

  const blob = new Blob([pdfBody], { type: "application/pdf" });
  const filename = title.toLowerCase().endsWith(".pdf") ? title : `${title}.pdf`;
  return new File([blob], filename, { type: "application/pdf" });
};

export const SAMPLE_DOCUMENTS_PRESETS = [
  {
    title: "Facture Orange Fibre Entreprise",
    partner: "Orange Côte d'Ivoire",
    docType: "Facture Fournisseur",
    folder: "401 - Achats & Fournisseurs",
    amount: 175000,
    aiClassification: "Classé à 99% par l'IA (OCR SYSCOHADA 401)",
  },
  {
    title: "Facture Client SENELEC Abidjan",
    partner: "SENELEC Climatisation",
    docType: "Facture Client",
    folder: "411 - Ventes & Clients",
    amount: 1450000,
    aiClassification: "Classé à 98% par l'IA (OCR SYSCOHADA 411)",
  },
  {
    title: "Relevé Compte Principal SGBCI",
    partner: "Société Générale (SGBCI)",
    docType: "Relevé Bancaire",
    folder: "52/57 - Trésorerie & Banques",
    amount: 3200000,
    aiClassification: "Classé à 99% par l'IA (OCR SYSCOHADA 52/57)",
  },
  {
    title: "Déclaration & Quittance TVA DGI",
    partner: "Direction Générale des Impôts (DGI)",
    docType: "Déclaration Fiscale",
    folder: "44 - Fiscalité & Taxes",
    amount: 480000,
    aiClassification: "Classé à 97% par l'IA (OCR SYSCOHADA 44)",
  },
  {
    title: "Bulletin Récapitulatif Salaires & CNPS",
    partner: "CNPS Caisse Nationale",
    docType: "Contrat / Bon",
    folder: "42 - Paie & Personnel",
    amount: 890000,
    aiClassification: "Classé à 96% par l'IA (OCR SYSCOHADA 42)",
  },
];
